/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * Contains enumerations used in Join Graph. Cardinality represents the relationship between two QuerySubjects. A seperate file is required for proper translation in JS.
 * @author  Alan.Tran@ibm.com
 */
export default class Cardinality extends Enum{

	static  ONE_TO_MANY = Cardinality.newLiteral("ONE_TO_MANY");

	static  MANY_TO_ONE = Cardinality.newLiteral("MANY_TO_ONE");

	static  ONE_TO_ONE = Cardinality.newLiteral("ONE_TO_ONE");

	static  MANY_TO_MANY = Cardinality.newLiteral("MANY_TO_MANY");


}


// WEBPACK FOOTER //
// ./src/generated/Cardinality.js